import { gql } from "@apollo/client";
export const WINE_DELETE = gql `
  mutation WineDelete($input: WineDeleteInput!) {
    WineDelete(input: $input)
  }
`;
